import { Injectable } from '@angular/core';
import firebase from 'firebase/compat/app';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseDatabaseService {
  private dbCallsRef = firebase.database().ref(`/tripmeld/calls/${localStorage.getItem("jti")}`);
  private dbClientsRef = firebase.database().ref(`/tripmeld/clients/${localStorage.getItem("CId")}`);
  private dbUserRef = firebase.database().ref(`/users/${localStorage.getItem("jti")}`);
  private dbTaskRemindersUserRef = firebase.database().ref(`/taskreminders/${localStorage.getItem("jti")}`);

  constructor() { }

  subscribeToCallsEvent(): Observable<any> {
    return new Observable(observer => {
      const callback = (snapshot: any) => {
        observer.next(snapshot.val());
      };

      const errorCallback = (error: any) => {
        observer.error(error);
      };

      this.dbCallsRef.on('value', callback, errorCallback);
      return () => {
        this.dbCallsRef.off('value', callback);
      };
    });
  }

  subscribeToClientsEvent(): Observable<any> {
    return new Observable(observer => {
      const callback = (snapshot: any) => {
        observer.next(snapshot.val());
      };

      const errorCallback = (error: any) => {
        observer.error(error);
      };

      this.dbClientsRef.on('value', callback, errorCallback);

      return () => {
        this.dbClientsRef.off('value', callback);
      };
    });
  }

  subscribeToUsersEvent(): Observable<any> {
    return new Observable(observer => {
      this.dbUserRef.on('value', (snapshot) => {
        observer.next(snapshot.val());
      }, (error) => {
        observer.error(error);
      });
    });
  }

  subscribeToTaskRemindersUsersEvent(): Observable<any> {
    return new Observable(observer => {
      this.dbTaskRemindersUserRef.on('value', (snapshot) => {
        observer.next(snapshot.val());
      }, (error) => {
        observer.error(error);
      });
    });
  }
}
